import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import * as shortcutMessageApis from "../../utilities/apis/shortcutMessage"
import Layout from "../../components/Layout"

const ShortcutMessages = () => {
  const { token, permissions } = useSelector(state => state.user)
  const modalRef = useRef(null)
  const [shortcutMessages, setShortcutMessages] = useState([])
  const [id, setId] = useState(null)
  const [shortcut, setShortcut] = useState("")
  const [message, setMessage] = useState("")

  const getModal = () => window.bootstrap.Modal.getOrCreateInstance(modalRef.current)

  const getShortcutMessages = async () => {
    try {
      const response = await shortcutMessageApis.getShortcutMessages(token, "")
      if (!response.status) throw new Error(response.message)

      setShortcutMessages(response.shortcut_messages)
    } catch (error) {
      alert(error.message)
    }
  }

  const handleNew = () => {
    setId(null)
    setShortcut("")
    setMessage("")
    getModal().show()
  }

  const handleEdit = async (id) => {
    try {
      const response = await shortcutMessageApis.getShortcutMessage(token, id)
      if (!response.status) throw new Error(response.message)

      setId(response.shortcut_message.id)
      setShortcut(response.shortcut_message.shortcut)
      setMessage(response.shortcut_message.message)
      getModal().show()
    } catch (error) {
      alert(error.message)
    }
  }

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const payload = { shortcut, message }
      const response = id
        ? await shortcutMessageApis.updateShortcutMessage(token, { ...payload, id })
        : await shortcutMessageApis.createShortcutMessage(token, payload)
      if (!response.status) throw new Error(response.message)

      getModal().hide()
      getShortcutMessages()
    } catch (error) {
      alert(error.message)
    }
  }

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await shortcutMessageApis.deleteShortcutMessage(token, id)
      if (!response.status) throw new Error(response.message)

      setShortcutMessages((previous) => previous.filter(x => x.id !== id))
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getShortcutMessages()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Shortcut Messages</p>
            {permissions["CREATE_SHORTCUT_MESSAGE"] && <button type="button" className="btn btn-theme rounded-4" onClick={handleNew}>New</button>}
          </div>

          <div className="border rounded-4">
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "20%" }} className="align-middle">Shortcut</th>
                  <th scope="col" style={{ width: "65%" }} className="align-middle">Message</th>
                  <th scope="col" style={{ width: "15%" }} className="align-middle text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {shortcutMessages.map((row) => {
                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle">{row.shortcut}</td>
                      <td className="align-middle text-break" style={{ whiteSpace: "pre-wrap" }}>{row.message}</td>
                      <td className="align-middle text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          {permissions["READ_SHORTCUT_MESSAGE"] && permissions["UPDATE_SHORTCUT_MESSAGE"] && <a role="button" className="text-theme" onClick={() => handleEdit(row.id)}><i className="far fa-edit"></i></a>}
                          {permissions["DELETE_SHORTCUT_MESSAGE"] && <a role="button" className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      <div ref={modalRef} className="modal fade" id="shortcutMessageModal" tabIndex="-1" aria-labelledby="shortcutMessageModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-md">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5 fw-bold" id="shortcutMessageModalLabel">{id ? "Edit" : "New"} Shortcut Message</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-column gap-3">
                  <div>
                    <label htmlFor="shortcut" className="form-label">Shortcut</label>
                    <input type="text" className="form-control" id="shortcut" maxLength={50} value={shortcut} onChange={(e) => setShortcut(e.target.value)} required />
                  </div>
                  <div>
                    <label htmlFor="message" className="form-label">Message</label>
                    <textarea className="form-control" id="message" rows={5} value={message} onChange={(e) => setMessage(e.target.value)} required></textarea>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-theme">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  )
}

export default ShortcutMessages
